export const rolesTabs = [
    { label: "Details", value: "details" },
  ];
  